import React, { useState } from "react";
import {
  Box,
  Container,
  Grid,
  makeStyles,
  // Accordion,
  // AccordionSummary,
  // AccordionDetails,
  // Slider,
  withStyles,
  FormControlLabel,
  Checkbox,
  Hidden,
  useMediaQuery,
  useTheme,
  Divider,
} from "@material-ui/core";
import InfiniteScroll from "react-infinite-scroll-component";
import HeaderSection from "../../components/reusableComponents/HeaderSection";
import { useSelector } from "react-redux";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useHistory, useLocation } from "react-router-dom";
const International = () => {
  const { flightreturn, loading,orderID } = useSelector((state) => state.home);
  const [scrollVal, SetScrollVal] = useState(10);
  const [data, setData] = useState(false);
  const history = useHistory()
  const [scrollValResult, SetScrollValResult] = useState(10);
  const [hasMoreresult, SethasMoreResult] = useState(true);
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const fetchMoreDataResult = () => {
    if (scrollValResult >= 200) {
      SethasMoreResult(false);
    }
    setTimeout(() => {
      SetScrollValResult(scrollValResult + 5);
    }, 500);
  };
  const location = useLocation()
  console.log("lo",location)
  function timeConvert(n) {
    var num = n;
    var hours = num / 60;
    var rhours = Math.floor(hours);
    var minutes = (hours - rhours) * 60;
    var rminutes = Math.round(minutes);
    return rhours + " hr and " + rminutes + " min.";
  }
  return (
    <>
      <HeaderSection id={1} />
      <Container>
        <Grid
          container
          alignItems="center"
          style={{ marginTop: 100 }}
          spacing={2}
        >
          {/* <Grid item xs={2}></Grid> */}
          <Grid item xs={12}>
            {loading ? (
              <>
                <div>please wait...</div>
              </>
            ) : (
              <InfiniteScroll
                dataLength={scrollValResult}
                next={fetchMoreDataResult}
                hasMore={hasMoreresult}
                loader={<h4>Loading...</h4>}
                endMessage={
                  <p style={{ textAlign: "center" }}>
                    <b>No More Data</b>
                  </p>
                }
              >
                {flightreturn &&
                  flightreturn.result &&
                  flightreturn.result.Response &&
                  flightreturn.result.Response.Results[0].map((item, index) => {
                    return index < scrollValResult ? (
                      <>
                        <Accordion
                          expanded={expanded === `panel${index + 1}`}
                          onChange={handleChange(`panel${index + 1}`)}
                        >
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                          >
                            <Grid container spacing={2}>
                              <Grid item xs={6}>
                                <Box
                                  display="flex"
                                  justifyContent="space-between"
                                >
                                  <Box style={{ display: "flex" }}>
                                    <img
                                      width="50px"
                                      height="50px"
                                      src={`https://nitish.musafirbazar.com/static/media/${item.Segments[0]
                                      .slice(0, 1)
                                      .map((i) => {
                                        return i.Airline.AirlineCode;
                                      })}.gif`}
                                    />
                                    <Box ml={"10px"}>
                                      <span>
                                        {item.Segments[0]
                                          .slice(0, 1)
                                          .map((i) => {
                                            return i.Airline.AirlineName;
                                          })}
                                      </span>
                                      <br></br>
                                      <span>
                                        {item.Segments[0]
                                          .slice(0, 1)
                                          .map((i) => {
                                            return i.Airline.AirlineCode;
                                          })}
                                      </span>
                                    </Box>
                                  </Box>
                                  <Box display="flex">
                                    <span>
                                      {item.Origin
                                        ? item.Origin
                                        : item.FareRules[0].Origin}
                                    </span>
                                    <span>-</span>
                                    <span>
                                      {" "}
                                      {item.Airline_Code
                                        ? item.Segments.length === 1
                                          ? item.Segments.filter(
                                              (i, index) => index === 0
                                            ).map((it) => {
                                              return it.Destination;
                                            })
                                          : item.Segments.length === 2
                                          ? item.Segments.filter(
                                              (i, index) => index === 1
                                            ).map((it) => {
                                              return it.Destination;
                                            })
                                          : item.Segments.length === 3
                                          ? item.Segments.filter(
                                              (i, index) => index === 2
                                            ).map((it) => {
                                              return it.Destination;
                                            })
                                          : ""
                                        : item.Segments[0].length == 2
                                        ? item.Segments[0]
                                            .filter((i, index) => index === 1)
                                            .map((it) => {
                                              return it.Destination.Airport
                                                .AirportCode;
                                            })
                                        : item.Segments[0].length == 3
                                        ? item.Segments[0]
                                            .filter((i, index) => index === 2)
                                            .map((it) => {
                                              return it.Destination.Airport
                                                .AirportCode;
                                            })
                                        : item.Segments[0].length == 1
                                        ? item.Segments[0].map((it) => {
                                            return it.Destination.Airport
                                              .AirportCode;
                                          })
                                        : ""}
                                    </span>
                                  </Box>
                                  <Box
                                    style={{ display: "flex" }}
                                    onClick={() =>
                                      data ? setData(false) : setData(true)
                                    }
                                  >
                                    <img
                                      width="50px"
                                      height="50px"
                                      src={`https://nitish.musafirbazar.com/static/media/${item.Segments[1]
                                      .slice(0, 1)
                                      .map((i) => {
                                        return i.Airline.AirlineCode;
                                      })}.gif`}
                                    />
                                    <Box ml={"10px"}>
                                      <span>
                                        {item.Segments[1]
                                          .slice(0, 1)
                                          .map((i) => {
                                            return i.Airline.AirlineName;
                                          })}
                                      </span>
                                      <br></br>
                                      <span>
                                        {item.Segments[1]
                                          .slice(0, 1)
                                          .map((i) => {
                                            return i.Airline.AirlineCode;
                                          })}
                                      </span>
                                    </Box>
                                  </Box>
                                </Box>
                              </Grid>
                              <Grid item xs={6}>
                                <Box
                                  display="flex"
                                  justifyContent="space-between"
                                >
                                   <Box display="flex">
                                    <span>
                                      {item.Segments[1].slice(0, 1).map((it)=>{
                                        return it.Origin.Airport.AirportCode
                                      })
                                    }
                                    </span>
                                    <span>-</span>
                                    <span>
                                      {" "}
                                      {item.Airline_Code
                                        ? item.Segments.length === 1
                                          ? item.Segments.filter(
                                              (i, index) => index === 0
                                            ).map((it) => {
                                              return it.Destination;
                                            })
                                          : item.Segments.length === 2
                                          ? item.Segments.filter(
                                              (i, index) => index === 1
                                            ).map((it) => {
                                              return it.Destination;
                                            })
                                          : item.Segments.length === 3
                                          ? item.Segments.filter(
                                              (i, index) => index === 2
                                            ).map((it) => {
                                              return it.Destination;
                                            })
                                          : ""
                                        : item.Segments[1].length == 2
                                        ? item.Segments[1]
                                            .filter((i, index) => index === 1)
                                            .map((it) => {
                                              return it.Destination.Airport
                                                .AirportCode;
                                            })
                                        : item.Segments[1].length == 3
                                        ? item.Segments[1]
                                            .filter((i, index) => index === 2)
                                            .map((it) => {
                                              return it.Destination.Airport
                                                .AirportCode;
                                            })
                                        : item.Segments[1].length == 1
                                        ? item.Segments[1].map((it) => {
                                            return it.Destination.Airport
                                              .AirportCode;
                                          })
                                        : ""}
                                    </span>
                                  </Box>
                                  <Box display="flex" >
                                    <h3>Rs {item.Fare.Total_Amount}</h3>
                                    <Box  onClick={() => {
                            history.push({
                              pathname: "/summaryflight",
                              state: {
                                orderID: orderID?.result,
                                // flightData:
                                //   resultSelection.length == 1
                                //     ? resultSelection
                                //     : onward.length == 1
                                //     ? onward
                                //     : "",
                                // selectedonward:
                                //   selectedonward.length == 1
                                //     ? selectedonward
                                //     : "",
                                // selectedReturn:
                                //   selectedReturn.length == 1
                                //     ? selectedReturn
                                //     : "",

                                // Returnflight:
                                //   resultRSelection.length == 1
                                //     ? resultRSelection
                                //     : returnD.length == 1
                                //     ? returnD
                                //     : "",
                                returnBody: location.state.returnBody,
                                intFlight:item,
                                // ID:
                                //   flightreturn &&
                                //   flightreturn.result &&
                                //   flightreturn.result.Response &&
                                //   flightreturn.result.Response.TraceId,
                                IDTBO:
                                  flightreturn &&
                                  flightreturn.result &&
                                  flightreturn.result.Response &&
                                  flightreturn.result.Response.TraceId,
                                // IDEtrav:
                                //   roundTripEtrav &&
                                //   roundTripEtrav.result &&
                                //   roundTripEtrav.result.Search_Key,
                              },
                            });
                          }}
                          textAlign="center"
                          
                                      style={{
                                        marginLeft: 20,
                                        background: "#ef631e",
                                        color: "white",
                                        borderRadius: "5px",
                                        padding: "0px 10px",
                                      }}
                                    >
                                      <h3>Book Now</h3>
                                    </Box>
                                  </Box>
                                </Box>
                              </Grid>
                            </Grid>
                          </AccordionSummary>
                          <AccordionDetails>
                            <Grid container spacing={2}>
                              <Grid item xs={6}>
                                {" "}
                                <Box style={{ marginTop: 25 }}>
                                  <span>Depart</span>
                                </Box>
                                <Box
                                  style={{
                                    padding: 10,
                                    border: "1px solid #ebe5e5",
                                  }}
                                >
                                  {item.Segments[0].map((i) => {
                                    return (
                                      <>
                                        <Box
                                          display="flex"
                                          style={{ marginTop: 10 }}
                                          justifyContent="space-between"
                                        >
                                          {" "}
                                          <Box>
                                            <span>
                                              {i.Origin.Airport.AirportCode}
                                            </span>
                                            <span style={{ marginLeft: 5 }}>
                                              ({i.Origin.Airport.CityName})
                                            </span>
                                            <span
                                              style={{
                                                marginLeft: 5,
                                                fontWeight: "bold",
                                              }}
                                            >
                                              {i.Origin.DepTime.substr(11, 5)}
                                            </span>
                                          </Box>
                                          <Box style={{ textAlign: "center" }}>
                                            <span>
                                              {timeConvert(i.Duration)}
                                            </span>
                                            <div className="ln"></div>
                                            <br></br>
                                            <span style={{ marginLeft: 5 }}>
                                              Non Stop
                                            </span>
                                          </Box>
                                          <Box>
                                            <span>
                                              {
                                                i.Destination.Airport
                                                  .AirportCode
                                              }
                                            </span>
                                            <span style={{ marginLeft: 5 }}>
                                              ({i.Destination.Airport.CityName})
                                            </span>
                                            <span
                                              style={{
                                                marginLeft: 5,
                                                fontWeight: "bold",
                                              }}
                                            >
                                              {i.Destination.ArrTime.substr(
                                                11,
                                                5
                                              )}
                                            </span>
                                          </Box>
                                        </Box>
                                      </>
                                    );
                                  })}
                                </Box>
                              </Grid>
                              <Grid item xs={6}>
                                {" "}
                                <Box style={{ marginTop: 20 }}>
                                  <span>Return</span>
                                </Box>
                                <Box
                                  style={{
                                    padding: 10,
                                    border: "1px solid #ebe5e5",
                                  }}
                                >
                                  {item.Segments[1].map((i) => {
                                    return (
                                      <>
                                        <Box
                                          display="flex"
                                          style={{ marginTop: 10 }}
                                          justifyContent="space-between"
                                        >
                                          {" "}
                                          <Box>
                                            <span>
                                              {i.Origin.Airport.AirportCode}
                                            </span>
                                            <span style={{ marginLeft: 5 }}>
                                              ({i.Origin.Airport.CityName})
                                            </span>
                                            <span
                                              style={{
                                                marginLeft: 5,
                                                fontWeight: "bold",
                                              }}
                                            >
                                              {i.Origin.DepTime.substr(11, 5)}
                                            </span>
                                          </Box>
                                          <Box style={{ textAlign: "center" }}>
                                            <span>
                                              {timeConvert(i.Duration)}
                                            </span>
                                            <div className="ln"></div>
                                            <br></br>
                                            <span style={{ marginLeft: 5 }}>
                                              Non Stop
                                            </span>
                                          </Box>
                                          <Box>
                                            <span>
                                              {
                                                i.Destination.Airport
                                                  .AirportCode
                                              }
                                            </span>
                                            <span style={{ marginLeft: 5 }}>
                                              ({i.Destination.Airport.CityName})
                                            </span>
                                            <span
                                              style={{
                                                marginLeft: 5,
                                                fontWeight: "bold",
                                              }}
                                            >
                                              {i.Destination.ArrTime.substr(
                                                11,
                                                5
                                              )}
                                            </span>
                                          </Box>
                                        </Box>
                                      </>
                                    );
                                  })}
                                </Box>
                              </Grid>
                            </Grid>
                          </AccordionDetails>
                        </Accordion>
                      </>
                    ) : (
                      ""
                    );
                  })}
              </InfiniteScroll>
            )}
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default International;
